export default {"src":"/_next/static/media/user-profile.af4d5cf7.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};